import { put, delay, takeLatest } from "@redux-saga/core/effects";
import { createEvent, deleteEvent, editEvent, fetchAllEvents, fetchEventById } from "../../../Utils/BackendAPICalls";
import { Actions, Types } from "../../Reducer/rootReducer";
import { CalendarEvent } from "../../../Types/UnitFeatureTypes";


interface EventAction {
    payload: {
        eventData: CalendarEvent;
    };
}

interface FetchEventAction {
    payload: {
        id?: number;
        start_date?: Date;
        end_date?: Date;
    };
}

interface DeleteEventAction {
    payload: {
        id: number;
    };
}

function* createEventRequestFunction(action: EventAction): Generator<any, void, any> {
    const { eventData } = action.payload;
    try {
        yield delay(100);
        const response: any = yield createEvent(eventData);
        if (!response || response?.error) {
            yield put(Actions.event.createEventRequestAction.failure({ message: response.error }));
        } else {
            yield put(Actions.event.createEventRequestAction.success({ id: response.id }));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.event.createEventRequestAction.failure(error));
    }
}

function* editEventRequestFunction(action: EventAction): Generator<any, void, any> {
    const { eventData } = action.payload;
    try {
        yield delay(100);
        const response: any = yield editEvent(eventData);
        if (!response || response?.error) {
            yield put(Actions.event.editEventRequestAction.failure({ message: response.error }));
        } else {
            yield put(Actions.event.editEventRequestAction.success({ id: response.id }));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.event.editEventRequestAction.failure(error));
    }
}

function* deleteEventRequestFunction(action: DeleteEventAction): Generator<any, void, any> {
    const { id } = action.payload;
    try {
        yield delay(100);
        const response: any = yield deleteEvent(id);
        if (!response || response?.error) {
            yield put(Actions.event.deleteEventRequestAction.failure({ message: response.error }));
        } else {
            yield put(Actions.event.deleteEventRequestAction.success());
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.event.deleteEventRequestAction.failure(error));
    }
}

function* fetchEventRequestFunction(action: FetchEventAction): Generator<any, void, any> {
    const { id, start_date, end_date } = action.payload;
    let response: any = null;
    try {
        yield delay(100);
        if (id) {
            response = yield fetchEventById(id);
        } else {
            const startDate = new Date();
            startDate.setDate(1);
            response = yield fetchAllEvents(start_date ?? startDate, end_date ?? new Date());
        }
        if (!response || response?.error) {
            yield put(Actions.fetchEvent.eventActions.failure({ message: response.error }));
        } else {
            yield put(Actions.fetchEvent.eventActions.success({ events: response.events, event: response.event, count: response.count }));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchEvent.eventActions.failure(error));
    }
}

export default function* eventSaga() {
    yield takeLatest(Types.CREATE_EVENT_REQUEST, createEventRequestFunction);
    yield takeLatest(Types.FETCH_EVENT_REQUEST, fetchEventRequestFunction)
    yield takeLatest(Types.EDIT_EVENT_REQUEST, editEventRequestFunction);
    yield takeLatest(Types.DELETE_EVENT_REQUEST, deleteEventRequestFunction);
}
